import React, { useEffect, useContext } from 'react';
import ReactGA from 'react-ga4';

import Menu from "./components/Menu/Menu";
import Spotify from "./components/Spotify/Spotify";
import TripleJ from "./components/TripleJ/TripleJ";
import Hottest100 from "./components/Hottest100/Hottest100";
import Home from "./components/Home";
import Companions from './components/Companions/Companions';
import Page404 from './components/Page404';
import Feedback from './components/Feedback';
import Logout from './components/Logout';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { TokenContext } from './components/Providers/TokenProvider';

import { generateCodeChallenge, generateCodeVerifier, GenerateSpotifyAccessToken } from './services/foundation';

import "./style/main.css"


function App() {

  ReactGA.initialize('G-8Q2C5MB5L5');

  const [ getToken, setToken ] = useContext(TokenContext);
  const [ cookies, setCookie ] = useCookies(['token']);


  useEffect(() => {

    async function codeChallenge() {
      const codeVerifier = generateCodeVerifier();
      const codeChallenge = await generateCodeChallenge(codeVerifier);
      localStorage.setItem("spotify_code_verifier", codeVerifier)
      localStorage.setItem("spotify_code_challenge", codeChallenge)
    }


    const spotifyCodeChallenge = localStorage.getItem("spotify_code_challenge");
    const SpotifyCodeVerifier = localStorage.getItem("spotify_code_verifier");

    if (spotifyCodeChallenge == null || SpotifyCodeVerifier == null) {
      codeChallenge();
    }

  }, []);

  useEffect(() => {
    async function thingyWrapper() {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");

      if (!getToken() && code) {
        const newToken = await GenerateSpotifyAccessToken(code, localStorage, window.location.origin);

        // Save token to context
        setToken(newToken);

        // Save refresh token in cookie
        if (newToken.refresh_token) {
          setCookie('spotify_refresh_token', newToken.refresh_token, {
            path: '/',
            maxAge: 60 * 60 * 24, // 1 day
            sameSite: 'lax'
          });
        }

        return;
      }
    }

    thingyWrapper();
  }, []);

  return (      
    <Router>
      <div id="content">
        <Menu />

        <Routes>
          <Route path='/' element={<Home />}> </Route>
          <Route path='/spotify/*' element={<Spotify />}> </Route>
          <Route path='/hottest-100/*' element={<Hottest100 />}> </Route>
          <Route path='/triple-j/*' element={<TripleJ />}> </Route>
          <Route path='/companions/*' element={<Companions />}> </Route>
          <Route path='/feedback/*' element={<Feedback />}> </Route>
          <Route path='/feedback/:type/*' element={<Feedback />}> </Route>
          <Route path='/logout/*' element={<Logout />}> </Route>
          <Route path='/logout/:type/*' element={<Logout />}> </Route>
          <Route path='/*' element={<Page404 />}></Route>
        </Routes>

      </div>
    </Router>
  );
}

export default App;
